import { getUserByEmail } from "../db/index.js";
import { setCredential } from "../db/credentials";
import { issueVerificationToken } from "./emailVerification";
import { initOnboarding, markEmailVerified, markPaidActivated, syncSessionOnboarding } from "./onboardingState";
import { issuePasswordResetToken } from "./passwordReset";
import { getSession, setSession } from "./authService";

export function finalizeNewAccount(session, role) {
  if (!session?.userId) return session;
  initOnboarding(session.userId, { role });
  issueVerificationToken(session.userId, session.email);
  const next = syncSessionOnboarding({ ...session, emailVerified: false });
  setSession(next);
  return next;
}

export function verifyEmailForUser(userId) {
  markEmailVerified(userId);
  const session = getSession();
  if (session?.userId === userId) {
    const next = syncSessionOnboarding({ ...session, emailVerified: true });
    setSession(next);
    return next;
  }
  return null;
}

export function activatePaidPlan(userId, planPatch = {}) {
  const session = getSession();
  if (session?.userId === userId) {
    markPaidActivated(userId);
    const next = syncSessionOnboarding({
      ...session,
      ...planPatch,
      plan_status: planPatch.plan_status || "active",
    });
    setSession(next);
    return next;
  }
  return null;
}

export function changeLocalPassword(userId, newPassword, { clearRotate = true } = {}) {
  if (!userId || !newPassword) throw new Error("Password required.");
  setCredential(userId, newPassword);
  const session = getSession();
  if (session?.userId === userId) {
    const next = { ...session, must_rotate: clearRotate ? false : session.must_rotate };
    setSession(next);
    return next;
  }
  return null;
}

export function requestPasswordReset(email) {
  const user = getUserByEmail(String(email || "").trim().toLowerCase());
  if (!user) {
    return { queued: true, message: "If that email is registered, a reset link has been queued." };
  }
  const token = issuePasswordResetToken(user.id, user.email);
  return {
    queued: true,
    userId: user.id,
    email: user.email,
    resetUrl: `${typeof window !== "undefined" ? window.location.origin : ""}/reset-password?token=${encodeURIComponent(token.token)}`,
    message: "If that email is registered, a reset link has been queued.",
  };
}
